<template>
  <b-card
    :header="$t('fCustomer_crdReports_title')"
    header-tag="h4"
    class="text-center"
  >
    <h1 class="card-title pricing-card-title">
      <span>{{ totalCount }}</span>
      <small class="text-muted">
        {{ $t('fCustomer_crdReports_item') }}
      </small>
    </h1>
    <ul
      class="list-unstyled mt-3 mb-3 text-muted"
    >
      <li>{{ sentCount }} {{ $t('fCustomer_crdReports_sentTitle') }}</li>
      <li>{{ receivedCount }} {{ $t('fCustomer_crdReports_receivedTitle') }}</li>
    </ul>
    <b-btn
      variant="primary"
      class="mt-auto"
      size="sm"
      block
      @click="$emit('on-show', itemId)"
    >
      {{ $t('fCustomer_crdReports_viewItem') }}
    </b-btn>
  </b-card>
</template>

<script>
import { mapComputedStateFields } from '~/mixins/globalForm'
export default {
  name: 'CardReports',
  props: {
    itemId: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    ...mapComputedStateFields('customerEdit', [
      'info'
    ]),
    totalCount () {
      return (this.info && this.info.reports.tot) || 0
    },
    sentCount () {
      return (this.info && this.info.reports.sent) || 0
    },
    receivedCount () {
      return (this.info && this.info.reports.received) || 0
    }
  }
}
</script>

<style scoped>

</style>
